/**
 * O PRAZO DE CADA REQUISIÇÃO (10/10/2026).
 *
 * A instância do axios não tinha timeout nenhum: requisição que não volta (backend reiniciando, conexão parada)
 * prendia a tela para sempre. Apareceu primeiro em Grupos Econômicos (o spinner que não saía, #415), mas valia para
 * qualquer carga do HUB. A regra:
 *
 *  - LEITURA (GET/HEAD) sem prazo próprio: 60 s. É a rede de proteção das cargas de tela.
 *  - ESCRITA (POST/PUT/PATCH/DELETE) sem prazo próprio: 10 min. Cortar uma escrita no meio NÃO a cancela no servidor:
 *    a fatura sai, o e-mail vai, e a tela diria "não respondeu". O operador tentaria de novo e duplicaria (o "não sei
 *    se gravou" que a #352 já teve de contornar). O teto de 10 min só impede o "para sempre".
 *  - Quem declara `timeout` próprio fica com o seu: as leituras que geram arquivo (PDF, Excel, zip, relatório) usam
 *    PRAZO_DE_ARQUIVO_MS, declarado em cada uma no api.ts.
 *
 * O erro de prazo vira "o servidor não respondeu em N s" (design/cargaDaLista → mensagemDoErroDeCarga).
 */
export const PRAZO_DE_LEITURA_MS = 60_000;
export const PRAZO_DE_ESCRITA_MS = 600_000;
/** Leitura que GERA arquivo no servidor (PDF renderizado, planilha, zip, relatório). */
export const PRAZO_DE_ARQUIVO_MS = 180_000;

export function prazoDaRequisicao(metodo: string | undefined, declarado: number | undefined | null): number {
  if (declarado && declarado > 0) return declarado;
  const m = String(metodo || 'get').toLowerCase();
  return m === 'get' || m === 'head' ? PRAZO_DE_LEITURA_MS : PRAZO_DE_ESCRITA_MS;
}
